import { attr, FASTElement, html, Updates } from "@microsoft/fast-element";
import { NatGenPortalOutlet } from "./portal-outlet";
import { NatGenDesignSystem } from "../../natgen-design-system";

/**
 * @element natgen-portal
 */
export class NatGenPortal extends FASTElement {
    @attr({ attribute: 'outlet-selector' }) outletSelector : string;

    observer: MutationObserver;

    connectedCallback(): void {
        this.observer = new MutationObserver(() => this.onContentChanged());
        this.observer.observe(this, { childList: true });

        Updates.enqueue(() => {
            this.getOutlet()?.attach(this);
        });
    }

    disconnectedCallback(): void {
        this.observer.disconnect();
        this.getOutlet().detach(this);
    }

    onContentChanged() : void {
        this.getOutlet().onPortalUpdate();
    }

    protected getOutlet() : NatGenPortalOutlet {
        var outlet = document.querySelector(this.outletSelector);

        if (!(outlet instanceof NatGenPortalOutlet)) {
            console.warn(`NatGenPortal outlet-selector (${this.outletSelector}) must point to a NatGenPortalOutlet.`);
            return;
        }

        return outlet;
    }
}

export const natGenPortalDefinition = NatGenPortal.compose({
    name: `${NatGenDesignSystem.prefix}-portal`,
    template: html<NatGenPortal>`
        <slot></slot>
    `
});
